import RankTwo from '@assets/icons/rank-two.svg'
import { Icon } from './Icon'

export const RankTwoIcon = Icon(RankTwo)
